module.exports = __webpack_public_path__ + "img/copart.71ac6863.svg";